module.exports = __webpack_public_path__ + "static/media/fly0170.b9ae95be.webp";